// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2qpuN","approved":"Status_approved__1jEbt","rejected":"Status_rejected__1mU0-","expired":"Status_expired__3f8-v","label":"Status_label__15Ndx"};